import { render, staticRenderFns } from "./UMLVOPhoto.vue?vue&type=template&id=067441c1&scoped=true&"
import script from "./UMLVOPhoto.vue?vue&type=script&lang=js&"
export * from "./UMLVOPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067441c1",
  null
  
)

export default component.exports